"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendZero = function (num) { return (num < 10 ? "0" + num : num); };
exports.getFormattedTime = function (time) {
    var dateTime = new Date(0, 0, 0, 0, 0, time, 0);
    var dateTimeH = exports.appendZero(dateTime.getHours());
    var dateTimeM = exports.appendZero(dateTime.getMinutes());
    var dateTimeS = exports.appendZero(dateTime.getSeconds());
    return (dateTimeH > 0 ? dateTimeH + ":" + dateTimeM + ":" + dateTimeS : dateTimeM + ":" + dateTimeS);
};
exports.getProgress = function (currentTime, duration) {
    return parseFloat((100 * (currentTime / duration)).toString());
};
exports.getCurrentTime = function (progress, duration) {
    return parseFloat(((progress * duration) / 100).toString());
};
exports.populateDispatch = function (dispatch, player) {
    var funcs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        funcs[_i - 2] = arguments[_i];
    }
    return funcs.reduce(function (acc, func) {
        acc.push(func(dispatch, player));
        return acc;
    }, []);
};
//# sourceMappingURL=helpers.js.map